module.exports = __webpack_public_path__ + "static/covid-19-4-2672fc9288f476bff48dc2debf1511e8.jpg";